import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Utils } from '../../../../../../common/js/Utils';
import { CoverpathUtils } from '../../../../../../coverpath-common/js/static/CoverpathUtils';
import { AmorphicService } from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { QuickQuoteService } from '../../../services/quote/quick-quote.service';
import { BaseQuoteCard } from './base-quote-card.component';
import { BasicIllustrationService } from '../../../../../../coverpath-common/angular/services/basicillustration/BasicIllustrationService';
import { Controller } from '../../../Controller';
import { CoverpathCustomer } from '../../../../../../coverpath-common/classes/coverpath_subclasses/CoverpathCustomer';
import { CoverpathAnnuityQuote } from '../../../../../../coverpath-common/classes/quote/coverpath/CoverpathAnnuityQuote';
import { productTypes } from '../../../../../../common/js/static/Product';
import { SafeInviteInfo } from '../../../../../../common/js/customer/SafeInviteInfo';

@Component({
  moduleId: module.id,
  selector: 'annuity-quote-card',
  templateUrl: './annuity-quote-card.component.html',
})
export class AnnuityQuoteCardComponent extends BaseQuoteCard implements OnInit {
  initialPurchaseAmount: string;
  ownerName: string;
  product: string = '';
  safeInviteInfo: SafeInviteInfo;

  constructor(
    protected amorphicService: AmorphicService,
    protected router: Router,
    protected quickQuoteService: QuickQuoteService,
    protected basicIllustrationService: BasicIllustrationService
  ) {
    super(amorphicService, router, quickQuoteService, basicIllustrationService);
    this.controller = amorphicService.controller as Controller;
  }

  ngOnInit(): void {
    this.controller.inviteController.getSafeInviteInfo().then((insuredInfo) => {
      this.safeInviteInfo = insuredInfo;
      this.updateProps();
    });
  }

  private updateProps(): void {
    if (!!this.safeInviteInfo === false) {
      return;
    }

    this.clientName = Utils.toCapitalizedWords(this.safeInviteInfo.primaryCustomer.firstName);

    const quote = this.quickQuoteService.getCurrentAgentQuote() as CoverpathAnnuityQuote;
    this.initialPurchaseAmount = Utils.formatCurrency(quote.initialPurchaseAmount, 0).toString();
    this.ownerName = Utils.toCapitalizedWords(this.safeInviteInfo.safePolicyInfo.primaryPolicy.owner.fullName);
    this.product = productTypes.Annuity.productNames[quote.product];
  }

  scrollToQuickQuote(): void {
    CoverpathUtils.scrollToElement('quick-quote');
  }
}
